import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { RoutePermission } from "../../shared/interface/route-permission";
import { CommonService } from "../../shared/services/common.service";

@Injectable()
export class AuthGuard implements CanActivate {
  permissionList: RoutePermission[];
  constructor(
    private router: Router, private _commonService: CommonService
  ) { }

  async  canActivate(routeSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isAuthorized = false;
    let storeId = +routeSnapshot.params['storeId'];
    state.url = state.url.split('#')[0];
    state.url = state.url.replace(/[0-9]/g, '');
    this.permissionList = await this._commonService.getRoutePermissions();
    let routePermission = this.permissionList.filter(x => x.path === state.url)[0];
   
    if (routePermission) {
      localStorage.setItem("appadmin.SideMenuPosition", JSON.stringify(routePermission.groupName));
      // this._cacheService.set(CacheKey.SideMenuPosition,routePermission.groupName);
      if (routePermission.allowAnonymous) {
        isAuthorized = true;
      } else {
        if (storeId > 0) {
          isAuthorized = this._commonService.checkPermissionList(routePermission.permissions,true, storeId);
        } else {
          isAuthorized = this._commonService.checkPermissionList(routePermission.permissions);
        }
        if (!isAuthorized) {
          localStorage.setItem("appadmin.SideMenuPosition", JSON.stringify(""));
          let redirect = '/admin/unauthorized';
          this.router.navigate([redirect]);
        }
      }
    }
    return isAuthorized;
  }

}  


// WEBPACK FOOTER //
// ./src/app/shared/guards/auth.guard.ts